class RoCrossSellingProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (! this.dataset.ak) {
      console.error('Cross sell products: API key is missing');
      return;
    }

    this.loadProductsWhenConsentApproved();
  }

  loadProductsWhenConsentApproved() {
    if (this.crossSellLoaded) {
      return;
    }

    if (typeof Clerk === 'function') {
      this.fetchClerkRecommendations();
      return;
    }

    const onClerkReady = () => {
      this.fetchClerkRecommendations();
      window.removeEventListener('ro:clerk-ready', onClerkReady);
      window.removeEventListener('ro:cookie-consent-updated', onConsentUpdated);
    };

    const onConsentUpdated = (event) => {
      if (event?.detail?.clerkConsentApproved === true && typeof Clerk === 'function') {
        this.fetchClerkRecommendations();
        window.removeEventListener('ro:clerk-ready', onClerkReady);
        window.removeEventListener('ro:cookie-consent-updated', onConsentUpdated);
      }
    };

    window.addEventListener('ro:clerk-ready', onClerkReady);
    window.addEventListener('ro:cookie-consent-updated', onConsentUpdated);
  }

  fetchClerkRecommendations() {
    if (this.crossSellLoaded || typeof Clerk !== 'function') {
      return;
    }

    this.crossSellLoaded = true;
    const productIds = this.dataset?.cartItemsProductIds.split(',').filter(id => id !== '');

    // Make the call to Clerk.io to get the product handles
    Clerk(
      'call',
      'recommendations/most_sold_with',
      {
        key: this.dataset.ak,
        limit: 2,
        attributes: ['handle'],
        exclude: [...productIds],
        products: productIds,
        filter: "variant_option_size in ['OS','UNI']"
      },
      function (response) {
        // Extract the handles from the Clerk.io response
        const handles = response.product_data.map((x) => x.handle);
        this.loadSection(handles);
      }.bind(this),
      function (response) {
        console.error('most_sold_with products: Clerk.io error:', response);
      }
    );
  }

  // Function to dynamically load the section
  loadSection(handles) {
    const url =
      window.location.pathname +
      '?sections=ro-cross-selling-products-content&handles=' +
      encodeURIComponent(handles.join(','));
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        // Insert the section content inside the container
        this.innerHTML = this.getSectionInnerHTML(data['ro-cross-selling-products-content']);
        // this.logProductClick();
      })
      .catch((error) => {
        console.error('Error loading the section:', error);
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('ro-cross-selling-products', RoCrossSellingProducts);

class RoCrossSellingItemQuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.crossSellingItem = this.closest('.js-cross-selling-item');
  }

  connectedCallback() {
    if (! this.crossSellingItem) {
      console.error('Cross selling item not found');
      return;
    }

    subscribe(PUB_SUB_EVENTS.cartError, (cartErrorData) => {
      if (this.crossSellingItem.dataset.variantId !== cartErrorData.productVariantId) {
        return;
      }

      this.notifyVariantOrderMaxQtyReached();
    });

    subscribe(PUB_SUB_EVENTS.variantOrderMaxQtyReached, (eventData) => {
      if (this.crossSellingItem.dataset.variantId !== eventData.variant) {
        return;
      }

      this.notifyVariantOrderMaxQtyReached();
    });
  }

  notifyVariantOrderMaxQtyReached() {
    const maxQuantityError = this.crossSellingItem.querySelector('.js-max-quantity-error');

    this.crossSellingItem.classList.remove('tw-border-lightgrey');
    this.crossSellingItem.classList.add('tw-border-red');
    maxQuantityError.classList.remove('tw-hidden');
    maxQuantityError.classList.add('tw-block');
  }
}

customElements.define('ro-cross-selling-item-quick-add-button', RoCrossSellingItemQuickAddButton);
